import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GeoJsonDataService {

  // Set up GeoJson BehaviorSubject
    private geoJsonSourceReach = new BehaviorSubject<GeoJsonDataReach[]>([]);
    private geoJsonSourceFacility = new BehaviorSubject<GeoJsonDataFacility[]>([]);
    private geoJsonSourcePointOfDiversion = new BehaviorSubject<GeoJsonDataPointOfDiversion[]>([]);
    currentGeoJsonReach = this.geoJsonSourceReach.asObservable();
    currentGeoJsonFacility = this.geoJsonSourceFacility.asObservable();
    currentGeoJsonPointOfDiversion = this.geoJsonSourcePointOfDiversion.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {

    // GET GeoJson data
    this.http.get(`${this.baseUrl}api/ReachGeoJson/`).subscribe(geoJsonApi => {
      this.changeGeoJsonReach(geoJsonApi['features']);
    });

    this.http.get(`${this.baseUrl}api/ProjectFacilityGeoJson/`).subscribe(geoJsonApi => {
      this.changeGeoJsonFacility(geoJsonApi['features']);
    });

    this.http.get(`${this.baseUrl}api/PermitPointOfDiversionGeoJson/`).subscribe(geoJsonApi => {
      this.changeGeoJsonPointOfDiversion(geoJsonApi['features']);
    });

  }

  // Functions to change GeoJson BehaviorSubjects
  changeGeoJsonReach(geoJson) {
    this.geoJsonSourceReach.next(geoJson);
    }
    changeGeoJsonFacility(geoJson) {
        this.geoJsonSourceFacility.next(geoJson);
    }
    changeGeoJsonPointOfDiversion(geoJson) {
        this.geoJsonSourcePointOfDiversion.next(geoJson);
    }

}

export interface GeoJsonDataReach {
  ReachNumber: string;
  ExcessFlowDate: Date;
  NaturalFlow: number;
  Gain: number;
  Demand: number;
  ExcessFlow: number;
  reachCoordinates: string;
  inView: boolean;
  selected: boolean;
}

export interface GeoJsonDataFacility {
    Id: number;
    Name: string;
    Description: string;
    inView: boolean;
    selected: boolean;
}

export interface GeoJsonDataPointOfDiversion {
    Id: number;
    Name: string;
    inView: boolean;
    selected: boolean;
}
